import * as actionTypes from "./actionTypes"
import Request from "../components/Request/Request"; 


function getLanguageItemSuccess(data) {
    return {
        type: actionTypes.GET_LANGUAGE_ITEM_SECCUSS,
        payload: data
    }
}

function getLanguageItemIstatisticsSuccess(data) {
    return {
        type: actionTypes.GET_LANGUAGE_ITEM_ISTATISTICS_SECCUSS,
        payload: data
    }
}


export function getList(languageCode) { 
    return function (dispatch) {
        let url = "/api/languageItem/get/" + languageCode;
        const request = new Request(url, "get");
        request.run()
            .then(response => {
               // debugger;
                dispatch(getLanguageItemSuccess(response.data.data));
            })
            .catch(error => {
 
            });
    }
}


export function getIstatisticsList() { 
    return function (dispatch) {
        let url = "/api/languageItem/getIstatisticList";
        const request = new Request(url, "get");
        request.run()
            .then(response => {
               // debugger;
                dispatch(getLanguageItemIstatisticsSuccess(response.data.data));
            })
            .catch(error => {
 
            });
    }
}
